module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon_indicated",
    class: {
      'activ_magnify': _vm.magnify, 'midSizeL': _vm.leftSize == 1, 'maxSizeL': _vm.leftSize == 2, 'minSizeL': _vm.leftSize == 0
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', {
    staticClass: "bgc_01"
  }, [_c('em', [_c('img', {
    attrs: {
      "src": require("../../../assets/project/images/map/car_icon_11.png"),
      "width": "14",
      "height": "24",
      "alt": ""
    }
  })]), _c('span', [_vm._v("行驶")])]), _vm._v(" "), _c('li', {
    staticClass: "bgc_02"
  }, [_c('em', [_c('img', {
    attrs: {
      "src": require("../../../assets/project/images/map/car_icon_12.png"),
      "width": "14",
      "height": "24",
      "alt": ""
    }
  })]), _c('span', [_vm._v("停车")])]), _vm._v(" "), _c('li', {
    staticClass: "bgc_03"
  }, [_c('em', [_c('img', {
    attrs: {
      "src": require("../../../assets/project/images/map/car_icon_13.png"),
      "width": "14",
      "height": "24",
      "alt": ""
    }
  })]), _c('span', [_vm._v("离线")])]), _vm._v(" "), _c('li', {
    staticClass: "bgc_04"
  }, [_c('em', [_c('img', {
    attrs: {
      "src": require("../../../assets/project/images/map/car_icon_14.png"),
      "width": "14",
      "height": "24",
      "alt": ""
    }
  })]), _c('span', [_vm._v("预警")])]), _vm._v(" "), _c('li', {
    staticClass: "bgc_05"
  }, [_c('em', [_c('img', {
    attrs: {
      "src": require("../../../assets/project/images/map/car_icon_15.png"),
      "width": "14",
      "height": "24",
      "alt": ""
    }
  })]), _c('span', [_vm._v("追车")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fa0433c","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/didivehiclemonitor/MenuStatus.vue
// module id = 1412
// module chunks = 0